import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "assets/css/orbit-up.css";

const Section = ({ title, children }) => (
  <section className="orbit-up-section">
    <h2>{title}</h2>
    {children}
  </section>
);

const Document = ({ title, children }) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | Eightfold`;
    window.scrollTo(0, 0);
    return () => { document.title = previousTitle; };
  }, [title]);

  return (
    <main className="orbit-up-page">
      <article className="orbit-up-document">
        <Link className="orbit-up-back" to="/">Nodra Studios</Link>
        {children}
      </article>
    </main>
  );
};

export const EightfoldPrivacyPolicy = () => (
  <Document title="Privacy Policy">
    <h1>Eightfold Privacy Policy</h1>
    <p className="orbit-up-updated"><strong>Last updated: September 27, 2026</strong></p>
    <p>Eightfold (the “app”) is a mobile game published by Nodra Studios. This policy explains what information is processed when you use the app.</p>
    <Section title="Information we process"><ul><li>The display name you choose and a unique user ID created for the leaderboard.</li><li>End-of-run score, survival time, kills, weapon, arena, bosses defeated, and app version.</li><li>Progress, settings, and inventory stored locally on your device.</li><li>Unity Ads may process device and advertising information to deliver and measure ads. This is governed by Unity’s privacy policy.</li></ul></Section>
    <Section title="How information is used"><p>Information is used to operate the game, preserve progress, display and validate leaderboard scores, deliver ads, and resolve technical issues. We do not sell this information or use it to create personalized profiles.</p></Section>
    <Section title="Third-party services"><p>Leaderboard data is sent to the Eightfold server. Ads are provided by Unity Ads. These services have their own privacy policies and data practices.</p></Section>
    <Section title="Retention and deletion"><p>The <strong>Delete account and data</strong> option in Settings deletes your account and all linked leaderboard runs from the server, and clears the local profile, progress, currency, upgrades, and inventory. You can then start a new empty profile with a new display name.</p></Section>
    <Section title="Children’s privacy"><p>Eightfold does not knowingly collect personal information from children under 13. If you believe such information has been submitted, please contact us.</p></Section>
    <Section title="Changes"><p>This policy may be updated. The current version will be published on this page.</p></Section>
    <Section title="Contact"><p>Support: <a href="mailto:support@nodrastudios.com">support@nodrastudios.com</a></p></Section>
  </Document>
);

export const EightfoldSupport = () => (
  <Document title="Support">
    <h1>Eightfold Support</h1>
    <p>For help, bug reports, or leaderboard deletion requests, contact <a href="mailto:support@nodrastudios.com">support@nodrastudios.com</a>.</p>
    <Section title="What to include"><p>Please include your device model, operating system version, app version, reproduction steps, and any error message or screenshot.</p></Section>
    <Section title="Leaderboard deletion requests"><p>Please include your display name and, if possible, the relevant leaderboard record. Never send passwords or payment information by email.</p></Section>
  </Document>
);
